import React from 'react';
import PropTypes from 'prop-types';
import AddRuleModal from './AddRuleModal';
import Column from 'components/ui/show/Column';
import GenericAddButton from 'components/button/GenericAddButton';
import InnerColumn from 'components/ui/show/InnerColumn';
import NoResults from 'components/form/styling/NoResults';
import RuleListItem from './RuleListItem';
import Section from 'components/ui/general/Section';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { getRuleConfig } from 'helpers/rulesHelper';

const StyledWrapper = styled.div`
    margin-bottom: 36px;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

class RulesContainer extends React.Component {
    constructor() {
        super();

        this.state = {
            discountRules: null,
            showRuleModal: false,
        };
    }

    handleDiscountRules = () => {
        const { rules, type } = this.props;
        const hasRules = !!rules && type in rules && !utils.isEmpty(rules[type]);

        if (hasRules) {
            const currentRulesAccordionStatus = rules[type].map((rule, index) => {
                const open = index === 0 ? true : false;

                return ({
                    ...rule,
                    open: open,
                    id: utils.uuid(),
                });
            });

            this.setState({
                discountRules: currentRulesAccordionStatus,
            });
        }
    };

    componentDidMount() {
        this.handleDiscountRules();
    }

    onToggleAddModal = () => {
        const { showRuleModal } = this.state;

        this.setState({
            showRuleModal: !showRuleModal,
        });
    };

    onUpdateRule = (id, ruleType, config) => {
        const {
            onUpdateRule,
            type,
        } = this.props;

        const {
            discountRules,
        } = this.state;

        const newDiscountRules = [
            ...discountRules,
        ];

        newDiscountRules.map((discountRule) => {
            if (discountRule.id === id && discountRule.type === ruleType) {
                discountRule.config = config;
            }

            return discountRule;
        });

        this.setState({
            discountRules: newDiscountRules,
        }, () => {
            onUpdateRule(newDiscountRules, type);
        });
    }

    onAddNewRule = (discountRuleName) => {
        const { discountRules: currentDiscountRules } = this.state;
        const { onUpdateRule, type } = this.props;

        const newDiscountRuleConfig = {
            id: utils.uuid(),
            ...getRuleConfig(discountRuleName),
            open: true,
        };

        const newDiscountsRule = [
            ...(!!currentDiscountRules && currentDiscountRules),
            newDiscountRuleConfig,
        ];

        this.setState({
            discountRules: newDiscountsRule,
        }, () => {
            onUpdateRule(newDiscountsRule, type);
        });

        this.onToggleAddModal();
    };

    onDeleteRule = (ruleId) => {
        const { discountRules: currentDiscountRules } = this.state;
        const { onUpdateRule, type } = this.props;

        const updatedRules = currentDiscountRules.filter((rule) => {
            return rule.id !== ruleId;
        });

        if (utils.isEmpty(updatedRules)) {
            return this.setState({
                discountRules: null,
            }, () => {
                onUpdateRule(null, type);
            });
        }

        this.setState({
            discountRules: updatedRules,
        }, () => {
            onUpdateRule(updatedRules, type);
        });
    };

    render() {
        const { discountRules, showRuleModal } = this.state;
        const { translate, type } = this.props;
        const ruleTitle = translate(`resources.discounts.rules.${ type }`);

        return (
            <StyledWrapper>
                <Section>
                    <Column
                        title={ ruleTitle }
                        actions={ <GenericAddButton handleOnClick={ this.onToggleAddModal } /> }
                    >
                        <InnerColumn>
                            { utils.isEmpty(discountRules) &&
                                <NoResults
                                    label={ translate('resources.discounts.rules.no_results', { type: ruleTitle.toLowerCase() }) }
                                />
                            }

                            { !utils.isEmpty(discountRules) &&
                                discountRules.map((discountRule) => {
                                    return (
                                        <RuleListItem
                                            key={ discountRule.id }
                                            rule={ discountRule }
                                            onUpdate={ this.onUpdateRule }
                                            onDeleteRule={ this.onDeleteRule }
                                        />
                                    );
                                })
                            }
                        </InnerColumn>
                    </Column>
                </Section>

                {
                    showRuleModal && <AddRuleModal onAddRule={ this.onAddNewRule } onCloseModal={ this.onToggleAddModal } type={ type } />
                }
            </StyledWrapper>
        );
    }
}

RulesContainer.propTypes = {
    onUpdateRule: PropTypes.func.isRequired,
    rules: PropTypes.object,
    translate: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
};

export default translate(RulesContainer);



// WEBPACK FOOTER //
// ./src/pages/discounts/rules/RulesContainer.js